'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

var TermsCondEN = require('../public/documents/Terms-and-Conditions-en.js');
var TermsCondES = require('../public/documents/Terms-and-Conditions-sp.js');
// var template = { __html: TermsCondES };

var SectionList = React.createClass({

  /**
   * @return {object}
   */
  render: function () {
    return <div>
      <FormatMessage locale={this.props.locale} path="compliancePage/customerDescription2" /><br /><br />
      <div className="row">
        <div className="col-sm-8 col-xs-8">
          <ul><li><FormatMessage locale={this.props.locale} path="compliancePage/customerList1" /></li>
            <li><FormatMessage locale={this.props.locale} path="compliancePage/customerList2" /></li>
            <li><FormatMessage locale={this.props.locale} path="compliancePage/customerList3" /></li>
          </ul><br /><br />
        </div>
      </div>
      <FormatMessage locale={this.props.locale} path="compliancePage/customerDescription3" /><br /><br />
    </div>
  }
});

var BfgCompliance = React.createClass({

  render: function () {
    var message = "";

    if (this.props.locale == 'en') {
      message = <SectionList locale={this.props.locale} />;
    }
    console.log("locale", this.props.locale)
    return (
      <div className="container" id="terms-cond-div" style={{ "marginTop": "5%", "marginBottom": "5%" }}>
        <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>

          <h3 className="text-center">
            <FormatMessage locale={this.props.locale} path="footer/footerTermsCond" />
          </h3>

          <hr className="small-blue" />
        </div>
        <div className="row text-justify" >
          {this.props.locale == 'es' ? <div dangerouslySetInnerHTML={{ __html: TermsCondES }} ></div> :
            <div dangerouslySetInnerHTML={{ __html: TermsCondEN }} ></div>
          }
        </div>
      </div>
    )
  }
})


module.exports = BfgCompliance



// WEBPACK FOOTER //
// ./js/TermsCond.js